import {
  CURRENT_USER_INFORMATION,
  ARTICLES_LIST,
  ARTICLES_SHOW,
  COUNTRIES_LIST,
  COUNTRIES_SHOW,
  DOMAINS_LIST,
  DOMAINS_SHOW,
  OPPORTUNITIES_LIST,
  OPPORTUNITIES_SHOW,
  SCHOOLS_LIST,
  SCHOOLS_SHOW,
  SUB_DOMAINS_LIST,
  SUB_DOMAINS_SHOW,
  FORMATIONS_LIST,
  FORMATIONS_SHOW,
  MEMBERS_LIST,
  SLIDERS_LIST,
  SOCIALS_LIST,
  VISIONS_LIST,
  APP_TOKEN_ASKED,
  APP_TOKEN_RETRIEVED,
  TOGGLE_PRELOADER,
  SCHOOLS_SEARCHES,
  SCHOOL_SLIDER_LIST,
  FAVORITE_SCHOOLS_LIST,
  FAVORITE_OPPORTUNITY_LIST
} from "../constants/constants";

import { SLIDERS, SOCIALS, VISIONS } from "../../helpers/constants";

const INITIAL_STATE = {
  school_sliders:[],
  sliders: [],
  visions: VISIONS,
  socials: SOCIALS,
  members: [],
  searchedItems: [],
  schools: [],
  school: {},
  countries: [],
  country: {},
  domains: [],
  domain: {},
  formations: [],
  formation: {},
  subDomains: [],
  subDomain: {},
  opportunities: [],
  opportunity: {},
  articles: [],
  article: {},
  tokenAsked: false,
  tokenRetrieved: false,
  tokenFailed: false,
  preloadMessage: "Chargement",
  isPreloader: false,
  currentUserInformation: {},
  step: "",
  favorite_schools:[],
  favorite_opportunity:[]
};

const rootReducer = (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    // HOME
    case SLIDERS_LIST:
      return { ...state, sliders: payload.data };
      case SCHOOL_SLIDER_LIST:
        return { ...state, school_sliders: payload.data };
    case VISIONS_LIST:
      return { ...state, visions: payload.data };
    case MEMBERS_LIST:
      return { ...state, members: payload.data };
    case SOCIALS_LIST:
      return { ...state, socials: payload.data };

    // SCHOOLS
    case SCHOOLS_LIST:
      return { ...state, schools: payload.data, searchedItems: payload.data };
    case SCHOOLS_SEARCHES:
      return { ...state, searchedItems: payload.data };
    case SCHOOLS_SHOW:
      return { ...state, school: payload.data };

    // COUNTRIES
    case COUNTRIES_LIST:
      return { ...state, countries: payload.data };
    case COUNTRIES_SHOW:
      return { ...state, country: payload.data };

    // DOMAINS
    case DOMAINS_LIST:
      return { ...state, domains: payload.data };
    case DOMAINS_SHOW:
      return { ...state, domain: payload.data };

    // FORMATIONS
    case FORMATIONS_LIST:
      return { ...state, formations: payload.data };
    case FORMATIONS_SHOW:
      return { ...state, formation: payload.data };

    // SUBDOMAINS
    case SUB_DOMAINS_LIST:
      return { ...state, subDomains: payload.data };
    case SUB_DOMAINS_SHOW:
      return { ...state, subDomain: payload.data };

    // OPPORTUNITIES
    case OPPORTUNITIES_LIST:
      return { ...state, opportunities: payload.data };
    case OPPORTUNITIES_SHOW:
      return { ...state, opportunity: payload.data };

    // ARTICLES
    case ARTICLES_LIST:
      return { ...state, articles: payload.data };
    case ARTICLES_SHOW:
      return { ...state, article: payload.data };

    // APP TOKEN
    case APP_TOKEN_ASKED:
      return { ...state, tokenAsked: true };
    case APP_TOKEN_RETRIEVED:
      return { ...state, tokenRetrieved: true };

    // PRELOADER
    case TOGGLE_PRELOADER:
      return {
        ...state,
        isPreloader: payload.isPreloader,
        preloadMessage: payload.preloadMessage,
      };
    
      case CURRENT_USER_INFORMATION: 
      return {...state, currentUserInformation:payload}
     
      case FAVORITE_SCHOOLS_LIST :
      return {...state,favorite_schools:payload.data}
      case FAVORITE_OPPORTUNITY_LIST :
      return {...state,favorite_opportunity:payload.data}
      // default:
      //   return {...state}
    default:
      return state;
  }
};

export default rootReducer;